var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDpdownPlaceholderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25613 2.10115C2.22678 2.12218 2.19875 2.14588 2.17237 2.17225C2.146 2.19862 2.1223 2.22666 2.10127 2.25601C1.93395 2.45794 1.83337 2.71718 1.83337 2.99992V12.9999C1.83337 13.6443 2.35571 14.1666 3.00004 14.1666H13C13.283 14.1666 13.5423 14.0659 13.7443 13.8984C13.7735 13.8774 13.8014 13.8538 13.8277 13.8276C13.8539 13.8013 13.8775 13.7734 13.8985 13.7442C14.066 13.5422 14.1667 13.2828 14.1667 12.9999V2.99992C14.1667 2.35559 13.6444 1.83325 13 1.83325H3.00004C2.71731 1.83325 2.45806 1.93383 2.25613 2.10115ZM12.8334 11.8904V3.16659H4.10952L12.8334 11.8904ZM11.8906 12.8333L3.16671 4.10939V12.8333H11.8906Z",
    fill: "#4A4C4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpdownPlaceholderIcon);
export default __webpack_public_path__ + "static/media/dpdown-placeholder-icon.943e6c9c18ccd0640728dcd987cb2dea.svg";
export { ForwardRef as ReactComponent };